module.exports = __webpack_public_path__ + "img/ctrl-ry-theta-dagger-stub--i.633b0cc9.svg";